import { createFeatureSelector, type MemoizedSelector } from '@ngrx/store';
import type { AppState } from '../app.state';
import type { State } from './entities.state';

export const selectEntitiesState: MemoizedSelector<AppState, State> = createFeatureSelector('entities');
